export const environment = {
  production: false,
  apiUrl: '/api',
  websocketUrl: '/api/hubs',
  reconnectionPolicy: [3000, 5000, 7000],
  authenticateWebsocket: true,
};
